module.exports = __webpack_public_path__ + "img/signSuccess.4c0815c1.png";